// extracted by mini-css-extract-plugin
export default {"flipperContainer":"GroupList_flipperContainer__44RaI","flipper":"GroupList_flipper__J-hDo"};